export type MarketingBatch = {
  batchId: string;
  reason: string;
  audience: string;
  eventTitle: string;
  eventStartDate: string;
  eventLocation: string;
  messageType: string;
  changeSummary?: string;
  templateName?: string;
  sent: number;
  delivered?: number;
  read?: number;
  failed: number;
  latestAt: string;
  queued?: number;
  templateMissing?: boolean;
};

const MARKETING_REPORT_KEY = 'milora-marketing-report';
const UPDATE_AUDIENCE_KEY = 'milora-event-update-audience';

export function storeUpdateAudience(eventId: string, audience: string) {
  localStorage.setItem(UPDATE_AUDIENCE_KEY, JSON.stringify({ eventId, audience }));
}

export function readUpdateAudience(eventId: string) {
  const raw = localStorage.getItem(UPDATE_AUDIENCE_KEY);
  if (!raw) return null;
  try {
    const stored = JSON.parse(raw) as { eventId?: string; audience?: string };
    if (stored.eventId !== eventId || !stored.audience) return null;
    return stored.audience;
  } catch {
    return null;
  }
}

export function storeMarketingReport(eventId: string, batch: MarketingBatch) {
  sessionStorage.setItem(MARKETING_REPORT_KEY, JSON.stringify({ eventId, batch }));
}

export function readMarketingReport(eventId: string): MarketingBatch | null {
  const raw = sessionStorage.getItem(MARKETING_REPORT_KEY);
  if (!raw) return null;
  try {
    const stored = JSON.parse(raw) as { eventId?: string; batch?: MarketingBatch };
    if (stored.eventId !== eventId || !stored.batch) return null;
    return stored.batch;
  } catch {
    return null;
  }
}

export function clearMarketingReport() {
  sessionStorage.removeItem(MARKETING_REPORT_KEY);
}
